module.exports = __webpack_public_path__ + "img/GN.2233c9ec.svg";